function Vector(props: any) {
    return (
        <div className={props.className}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1007 2" >
                <path d="M0 1H1007" stroke="#EBEBEB"/>
            </svg>
        </div>);
}

export default Vector;